import { dateTimeFormat, formattedDateTimezone } from 'helpers/utils';
import { TCreateConverter, TFetchConverter } from '../types/converter.types';
import {
  EFollowUpMedium,
  TAddTenantFollowUpItemDB,
  TAddTenantFollowUpItemUI,
  TEditTenantFollowUpItemDB,
  TEditTenantFollowUpItemUI,
  TFollowUpItemDB,
  TFollowUpItemUI,
} from '../types/tenant.types';
import { animalResidencyStatusConverter } from './residence.converters';

export const getFollowUpItemMediumDisplayValue = (medium: EFollowUpMedium) => {
  const mediumDisplayValues: { [key in EFollowUpMedium]: string } = {
    [EFollowUpMedium.SMS]: 'Text Message',
    [EFollowUpMedium.EMAIL]: 'Email Notification',
  };
  return mediumDisplayValues[medium];
};

export const tenantFollowUpItemConverter: TFetchConverter<TFollowUpItemUI, TFollowUpItemDB> = {
  fromDb: (data) => {
    return {
      id: data.id,
      animals: (data.animals || []).map((animal) => ({
        ...animal,
        residencyStatus: animal?.residencyStatus && animalResidencyStatusConverter.fromDb(animal.residencyStatus),
      })),
      author: data.author,
      description: data.description,
      isEditable: data.isEditable,
      medium: data.medium,
      occurredOn: formattedDateTimezone(data.occurredOn, dateTimeFormat),
    };
  },
};

export const addTenantFollowUpItemConverter: TCreateConverter<TAddTenantFollowUpItemUI, TAddTenantFollowUpItemDB> = {
  toDb: (data) => {
    return {
      tenantId: data.tenantId,
      description: data.description,
      animalIds: data.animalIds?.length ? data.animalIds : null,
    };
  },
};

export const editTenantFollowUpItemConverter: TCreateConverter<TEditTenantFollowUpItemUI, TEditTenantFollowUpItemDB> = {
  toDb: (data) => {
    const { initialAnimals, finalAnimals } = data;
    const addedAnimals = finalAnimals.filter((id) => !initialAnimals.includes(id));
    const removedAnimals = initialAnimals.filter((id) => !finalAnimals.includes(id));
    return {
      tenantId: data.tenantId,
      description: data.description,
      tenantFollowUpItemId: data.tenantFollowUpItemId,
      addedAnimals: addedAnimals.length ? addedAnimals : null,
      removedAnimals: removedAnimals.length ? removedAnimals : null,
    };
  },
};
